// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vc-nav-popover-container{background-color:#81c7bd!important;border-color:#84c8bf!important}.vc-nav-arrow:hover{background:none!important}", ""]);
// Exports
module.exports = exports;
